import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/sections/Hero';
import './Home.css';
import playground from '../Asset/images/playground.jpg';
import kids from '../Asset/images/preschool.jpg';
import read from '../Asset/images/studentread.jpg';
import comp from '../Asset/images/studentcomp.jpg';
import campus from '../Asset/images/campus.jpg';
import classroom from '../Asset/images/classroom.jpg';

/* ── Feature data ── */
const features = [
  {
    id: 'student',
    label: 'Student Centred',
    svg: (
      <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect x="8" y="12" width="48" height="40" rx="3" stroke="currentColor" strokeWidth="2.5"/>
        <line x1="8" y1="22" x2="56" y2="22" stroke="currentColor" strokeWidth="2.5"/>
        <line x1="18" y1="32" x2="46" y2="32" stroke="currentColor" strokeWidth="2"/>
        <line x1="18" y1="40" x2="38" y2="40" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
  },
  {
    id: 'teachers',
    label: 'Qualified Teachers',
    svg: (
      <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <circle cx="32" cy="20" r="10" stroke="currentColor" strokeWidth="2.5"/>
        <path d="M18 50c0-10 6-16 14-16s14 6 14 16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M38 28l6 4-6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    id: 'curriculum',
    label: 'British Curriculum',
    svg: (
      <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect x="16" y="10" width="32" height="9" rx="2" stroke="currentColor" strokeWidth="2.5"/>
        <path d="M20 19v26l12-6 12 6V19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="24" y1="27" x2="32" y2="27" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
  },
  {
    id: 'extracurr',
    label: 'Extra Curriculum',
    svg: (
      <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <circle cx="32" cy="24" r="9" stroke="currentColor" strokeWidth="2.5"/>
        <path d="M20 46c0-7 5-12 12-12s12 5 12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="32" cy="52" r="4" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'online',
    label: 'Online Education',
    svg: (
      <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect x="10" y="14" width="44" height="30" rx="3" stroke="currentColor" strokeWidth="2.5"/>
        <circle cx="32" cy="29" r="7" stroke="currentColor" strokeWidth="2"/>
        <line x1="22" y1="50" x2="42" y2="50" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id: 'classsize',
    label: 'Small Class Size',
    svg: (
      <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect x="8" y="18" width="48" height="30" rx="3" stroke="currentColor" strokeWidth="2.5"/>
        <line x1="18" y1="28" x2="28" y2="28" stroke="currentColor" strokeWidth="2"/>
        <line x1="18" y1="35" x2="46" y2="35" stroke="currentColor" strokeWidth="2"/>
        <line x1="18" y1="42" x2="46" y2="42" stroke="currentColor" strokeWidth="2"/>
        <circle cx="46" cy="28" r="4" fill="currentColor"/>
      </svg>
    ),
  },
];

/* ── School data ── */
const schools = [
  {
    id: 'preschool',
    name: 'Pre-School',
    description: '5 levels from Toddlers to Reception 2',
    image: kids,
    alt: 'Pre-School students',
    accentClass: 'accent--red',
    anchor: '/academics#preschool',
    showActions: true,
  },
  {
    id: 'primary',
    name: 'Primary',
    description: 'Grades 1 through 6',
    image: classroom,
    alt: 'Primary school classroom',
    accentClass: 'accent--green',
    anchor: '/academics#primary',
    showActions: true,
  },
  {
    id: 'jhs',
    name: 'Junior High',
    description: null,
    badge: 'JHS 1 Currently',
    image: campus,
    alt: 'Junior High School campus',
    accentClass: 'accent--navy',
    anchor: null,
    showActions: false,
  },
];

const Home = () => (
  <div className="home-page">
    <Hero />

    {/* ══════════════════════════════════════
        WELCOME SECTION
    ══════════════════════════════════════ */}
    <section className="welcome" aria-labelledby="welcome-heading">
      <div className="container welcome__grid">

        {/* Text */}
        <div className="welcome__text">
          <p className="eyebrow">Welcome to</p>
          <h1 id="welcome-heading" className="welcome__name">
            Star Hacs International School
          </h1>
          <span className="rule" aria-hidden="true" />
          <p className="welcome__body">
            Star Hacs International School is a private educational institution
            established to provide quality international education to students of
            all backgrounds. Based on the firm belief that every child is a unique
            individual with the potential for excellence, all our academic and
            extracurricular programmes are designed to foster a positive self-image
            in our learners, whilst facilitating their intellectual, social,
            emotional and physical development.
          </p>
          <Link to="/about" className="btn btn--primary">
            Read More
          </Link>
        </div>

        {/* Image grid */}
        <div className="welcome__grid-images" aria-hidden="true">
          <div className="img-tile img-tile--tall">
            <img src={comp} alt="" className="img-tile__img" loading="lazy" />
          </div>
          <div className="img-tile">
            <img src={read} alt="" className="img-tile__img" loading="lazy" />
          </div>
          <div className="img-tile">
            <img src={classroom} alt="" className="img-tile__img" loading="lazy" />
          </div>
          <div className="img-tile img-tile--accent">
            <img src={playground} alt="" className="img-tile__img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    {/* ══════════════════════════════════════
        OUR SCHOOLS SECTION
    ══════════════════════════════════════ */}
    <section className="schools" aria-labelledby="schools-heading">
      <div className="container">
        <header className="section-header">
          <div>
            <p className="eyebrow">What we offer</p>
            <h2 id="schools-heading" className="section-title">Our Schools</h2>
          </div>
          <p className="section-subtitle">
            Star Hacs International comprises of the following:
          </p>
        </header>

        <div className="schools__list">
          {schools.map(({ id, name, description, badge, image, alt, accentClass, anchor, showActions }) => (
            <article key={id} className={`school-card ${accentClass}`}>
              <div className="school-card__media">
                <img src={image} alt={alt} className="school-card__img" loading="lazy" />
              </div>
              <div className="school-card__body">
                <h3 className="school-card__name">{name}</h3>
                <span className="school-card__rule" aria-hidden="true" />
                {description && (
                  <p className="school-card__desc">{description}</p>
                )}
                {badge && (
                  <span className="school-card__badge">{badge}</span>
                )}
                {showActions && (
                  <div className="school-card__actions">
                    <Link to="/admissions" className="btn btn--primary btn--sm">
                      Apply Now
                    </Link>
                    <Link to={anchor} className="btn btn--ghost btn--sm">
                      Learn more <span aria-hidden="true">→</span>
                    </Link>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    {/* ══════════════════════════════════════
        WHY CHOOSE US SECTION
    ══════════════════════════════════════ */}
    <section className="why" aria-labelledby="why-heading">
      <div className="container why__grid">

        {/* Image */}
        <div className="why__media">
          <img
            src={kids}
            alt="Star Hacs students learning together"
            className="why__img"
            loading="lazy"
          />
          <div className="why__media-badge" aria-hidden="true">
            <span className="why__media-badge-num">500+</span>
            <span className="why__media-badge-label">Happy Students</span>
          </div>
        </div>

        {/* Features */}
        <div className="why__content">
          <p className="eyebrow">Why choose us</p>
          <h2 id="why-heading" className="section-title">
            A School Built for Every Child
          </h2>
          <span className="rule" aria-hidden="true" />
          <ul className="features">
            {features.map(({ id, label, svg }) => (
              <li key={id} className="feature">
                <div className="feature__icon" aria-hidden="true">{svg}</div>
                <span className="feature__label">{label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  </div>
);

export default Home;